const pad = (n) => String(n).padStart(2, "0");

export function datetimeLocalNow() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
    d.getMinutes(),
  )}`;
}

export function datetimeLocalStartOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00`;
}

export function mysqlOrIsoToDatetimeLocalMin(value) {
  if (value == null || value === "") return datetimeLocalStartOfToday();
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const d = value;
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
      d.getMinutes(),
    )}`;
  }
  const s = String(value).trim().replace(" ", "T");
  return s.length >= 16 ? s.slice(0, 16) : s;
}

export function parseMovementInstantMsFromLocalInput(datetimeLocal) {
  if (datetimeLocal == null || String(datetimeLocal).trim() === "") return null;
  const s = String(datetimeLocal).trim();
  const normalized = s.length === 16 ? `${s}:00` : s;
  const t = new Date(normalized).getTime();
  return Number.isNaN(t) ? null : t;
}

export function parseMovementInstantMsFromDbOrIso(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value.getTime();
  const s = String(value).trim().replace(" ", "T");
  if (!s) return null;
  const withSecs =
    s.length >= 19 ? s : s.length === 16 ? `${s}:00` : s.includes("T") ? `${s}:00` : `${s.replace(" ", "T")}:00`;
  const t = new Date(withSecs).getTime();
  return Number.isNaN(t) ? null : t;
}

export function validateReturnInTimeAgainstOut(inDatetimeLocal, outTimeFromRow) {
  const tin = parseMovementInstantMsFromLocalInput(inDatetimeLocal);
  const tout = parseMovementInstantMsFromDbOrIso(outTimeFromRow);
  if (tin == null) return { ok: false, message: "Invalid in time" };
  if (tout == null) return { ok: true };
  if (tin < tout) {
    return { ok: false, message: "In time cannot be earlier than out time" };
  }
  return { ok: true };
}
